import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import Stack from "react-bootstrap/Stack";
import { useModal } from "../../../providers/ModalProvider/ModalProvider";
import send from "../../../assets/icons/send.svg";
import copy from "../../../assets/icons/copy.svg";
// import download from "../../../assets/icons/download.svg";
import { useEffect, useRef, useState } from "react";
import { sendInvoice } from "../../../utilities/api";
import { paymentStatuses } from "../../../utilities/helpers";
// import { sendInvoice } from "../../../utilities/api";

export default function ViewInvoices({ order }) {
  const { closeModal } = useModal();
  const [loadingStates, setLoadingStates] = useState({});

  const handleSendInvoice = async (invoice, index) => {
    setLoadingStates((prev) => ({ ...prev, [`send_${index}`]: true }));

    try {
      const res = await sendInvoice(invoice);
    } catch (error) {
      console.error("Error sending invoice:", error);
    } finally {
      setLoadingStates((prev) => ({ ...prev, [`send_${index}`]: false }));
    }
  };

  const handleCopyLink = async (invoice, index) => {
    setLoadingStates((prev) => ({ ...prev, [`copy_${index}`]: true }));

    setTimeout(() => {
      navigator.clipboard.writeText(invoice?.stripeInvoiceLink);
      setLoadingStates((prev) => ({ ...prev, [`copy_${index}`]: false }));
    }, 400);
  };

  //   const handleDownload = async (invoice, index) => {
  //     setLoadingStates((prev) => ({ ...prev, [`download_${index}`]: true }));

  //     try {
  //       // Fetch the PDF file
  //       const response = await fetch(invoice?.stripeInvoicePdf);

  //       if (!response.ok) {
  //         throw new Error(`Failed to download: ${response.statusText}`);
  //       }

  //       // Convert response to blob
  //       const blob = await response.blob();

  //       // Create download link
  //       const url = window.URL.createObjectURL(blob);
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.download = `invoice-${invoice?.id || "unknown"}.pdf`; // Use invoice ID or fallback

  //       // Append to body, click, and remove
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);

  //       // Clean up the object URL
  //       window.URL.revokeObjectURL(url);
  //     } catch (error) {
  //       console.error("Error downloading invoice:", error);
  //     } finally {
  //       setLoadingStates((prev) => ({ ...prev, [`download_${index}`]: false }));
  //     }
  //   };
  return (
    <>
      <Modal.Header closeButton className="border-0 pb-0 mb-4">
        <Modal.Title className="h4 text-dark">Order Invoices</Modal.Title>
      </Modal.Header>

      <Modal.Body className="pb-4 px-4">
        {order?.stripe_invoices && order.stripe_invoices.length > 0 ? (
          <Stack direction="vertical" gap={4} className="mx-0">
            {order.stripe_invoices.map((invoice, i) => (
              <Card key={i} className="border-0 h-100">
                <Card.Body className="p-0">
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="text-dark fw-semibold mb-0">
                      Invoice #{invoice.id || "N/A"}
                    </h6>
                    <div className="d-flex gap-2">
                      <Badge
                        key="payment-status"
                        bg="none"
                        className={`badge-sm badge--${paymentStatuses[invoice?.paymentStatus]?.value}`}
                      >
                        {paymentStatuses[invoice?.paymentStatus]?.label}
                      </Badge>
                      <div className="d-flex gap-2">
                        {/* Send Invoice Button */}
                        {/* Comment out for now - may delete because no one will do this - if they need to send invoice they could just copy and email the link */}
                        {/* <IconButton
                          icon={
                            <img src={send} alt="send" height={24} width={24} />
                          }
                          title="Send Invoice"
                          isLoading={loadingStates[`send_${i}`]}
                          onClick={() => handleSendInvoice(invoice, i)}
                          disabled={invoice?.stripeInvoiceId === undefined}
                        /> */}

                        {/* Copy Link Button */}
                        <IconButton
                          icon={
                            <img src={copy} alt="copy" height={24} width={24} />
                          }
                          title="Copy Invoice Link"
                          isLoading={loadingStates[`copy_${i}`]}
                          onClick={() => handleCopyLink(invoice, i)}
                          disabled={invoice?.stripeInvoiceLink === undefined}
                        />

                        {/* Download Button */}
                        {/* <IconButton
                          icon={
                            <img
                              src={download}
                              alt='download'
                              height={24}
                              width={24}
                            />
                          }
                          title='Download Invoice'
                          isLoading={loadingStates[`download_${i}`]}
                          onClick={() => handleDownload(invoice, i)}
                        /> */}
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            ))}
          </Stack>
        ) : (
          <div className="text-center py-5">
            <i className="bi bi-inbox display-1 text-muted"></i>
            <h5 className="text-muted">No invoices found</h5>
            <p className="text-muted mb-0">
              This order doesn't have any associated invoices.
            </p>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="border-0 pt-0 px-3">
        <Button variant="primary" onClick={closeModal} className="px-4">
          Close
        </Button>
      </Modal.Footer>
    </>
  );
}

const IconButton = ({
  icon,
  title,
  onClick,
  isLoading = false,
  className = "",
  ...buttonProps
}) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const timeoutRef = useRef(null);

  // Clean up timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  // Handle success state when loading changes from true to false
  useEffect(() => {
    if (!isLoading && showSuccess === false) {
      // Only show success if we were previously loading
      const wasLoading = timeoutRef.current !== null;
      if (wasLoading) {
        setShowSuccess(true);
        timeoutRef.current = setTimeout(() => {
          setShowSuccess(false);
          timeoutRef.current = null;
        }, 600);
      }
    }
  }, [isLoading, showSuccess]);

  // Set timeout ref when loading starts
  useEffect(() => {
    if (isLoading) {
      timeoutRef.current = true; // Mark that we're loading
    }
  }, [isLoading]);

  const renderIcon = () => {
    if (isLoading) {
      return (
        <div
          className="spinner-border text-muted spinner-border-sm"
          role="status"
          style={{ width: "22px", height: "22px" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      );
    }

    if (showSuccess) {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 12l4 4 8-8"
            stroke="#777e90"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    }

    return icon;
  };

  return (
    <Button
      variant="link"
      size="sm"
      className={`p-1 d-flex align-items-center justify-content-center ${className}`}
      style={{ width: "32px", height: "32px" }}
      title={title}
      onClick={onClick}
      disabled={isLoading}
      {...buttonProps}
    >
      {renderIcon()}
    </Button>
  );
};
